import { RSAA } from 'redux-api-middleware';
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from '../../config/ApiConstants';


export function profileMeAPI_Action(token, groupId = '') {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/me/profile`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                'Authorization': 'Bearer ' + token,
                groupId: groupId
                },
            body: '',
            types: [
                types.PROFILE_ME_REQUEST,
                types.PROFILE_ME_RECEIVE, {
                    type: types.PROFILE_ME_FAILURE,
                    meta: (action, state, res) => {
                        return (action, state, res);
                    }
                }]
        }
    }
}

export const resetprofileMeAPI_Action = () => {
    return {
        type: types.RESET_PROFILE_ME,
        payload: null
    }
};
